export default {"src":"/_next/static/media/ra-aircraft-golf.b1f3f4a3.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};